import studentProfile from '../../../apis/studentProfile';

export const uploadPhoto = async (
  file: File,
  id: string,
  isGuardian: boolean
) => {
  try {
    const response = await studentProfile.uploadProfilePhoto(
      id,
      file,
      isGuardian
    );
    return response as any;
  } catch (error: any) {
    return error;
  }
};
